export default __webpack_public_path__ + "static/media/learose5-1024w.2e910d0e.png";